import { useContext } from 'react';

import TscAuthContext from './tsc-auth-context';
import type { TscAuthContextInterface } from './types';

export const useTscAuth = (context = TscAuthContext): TscAuthContextInterface =>
  useContext(context);
